/* Prestige Watch — pw-anime.js
   Anime.js v4 accent layer, deliberately separate from pw-motion.js.
   Anime owns TRANSFORM + CSS-variable + counter text ONLY. Motion owns opacity.
   All effects progressive-enhance visible content; reduced motion stays static. */
(function () {
  'use strict';
  var A = window.anime;
  if (!A || typeof A.animate !== 'function' || typeof A.onScroll !== 'function') return;
  var mqReduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
  if (mqReduce && mqReduce.matches) return;
  var registry = [];
  function track(x) { if (x) registry.push(x); return x; }
  function safe(fn) { try { return fn(); } catch (e) { return null; } }
  function stopAll() { registry.forEach(function (a) { try { a.revert && a.revert(); } catch (e) {} }); registry.length = 0; }
  if (mqReduce && mqReduce.addEventListener) mqReduce.addEventListener('change', function () { if (mqReduce.matches) stopAll(); });

  /* ---------- 1. Hero dial: true continuous sweep ---------- */
  safe(function () {
    var dial = document.querySelector('.pw-dial');
    var hourHand = dial && dial.querySelector('span');
    if (!hourHand) return;
    /* Anime.js v4 keeps parameters in the properties object (not arg 3). */
    track(A.animate(hourHand, { rotate: [35, 395], duration: 90000, ease: 'linear', loop: true }));
    /* Minute hand pseudo-element is driven by CSS custom property. */
    track(A.animate(hourHand, { '--pw-minute': [-100, 260], duration: 60000, ease: 'linear', loop: true }));
  });

  /* ---------- 2. Staggered rise on the principles column ----------
     Trigger via IntersectionObserver and set the start offset ONLY at trigger
     time, so a missed trigger leaves the text in its natural position
     (Anime.js scroll-sync would apply the start offset immediately and could
     strand elements 22px low). */
  safe(function () {
    var container = document.querySelector('.pw-principles');
    var items = container ? container.querySelectorAll('article') : [];
    if (items.length < 2) return;
    var done = false;
    var fire = function () {
      if (done) return;
      done = true;
      track(A.animate(items, { translateY: [22, 0], duration: 650, delay: A.stagger(70), ease: 'out(3)' }));
    };
    if (!('IntersectionObserver' in window)) return; /* text already readable */
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { fire(); io.disconnect(); }
      });
    }, { rootMargin: '0px 0px -10% 0px' });
    io.observe(container);
  });

  /* ---------- 3. Keep 01/02/03 step markers legible; gentle one-shot number count ---------- */
  safe(function () {
    document.querySelectorAll('.pw-number').forEach(function (el) {
      var raw = (el.textContent || '').trim();
      var target = parseInt(raw, 10);
      if (isNaN(target) || target <= 0) return;
      var obj = { v: target };
      /* Stable display at all times: animate text only when target is first seen.
         A count-up is cosmetic; if scroll skips the point, text is still correct. */
      var started = false;
      var start = function () {
        if (started) return;
        started = true;
        obj.v = 0;
        track(A.animate(obj, { v: target, modifier: A.utils.round(0), duration: 650, ease: 'out(3)',
          onUpdate: function () { el.textContent = String(obj.v).padStart(2, '0'); },
          onComplete: function () { el.textContent = raw; }
        }));
      };
      if (typeof A.onScroll === 'function') {
        /* ScrollObserver fires callback while crossing; exact number remains until animation begins. */
        var observer=A.onScroll({target:el,enter:'top bottom',leave:'bottom top',sync:false,onEnter:start});
        track(observer);
      } else start();
    });
  });

  /* ---------- 4. Product gallery settle on variant/photo change ---------- */
  safe(function () {
    var gal = document.querySelector('.my-gallery img, .photos__item--main img');
    if (!gal || !window.MutationObserver) return;
    new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        if (m.attributeName === 'src') track(A.animate(gal, { scale: [1.025, 1], duration: 480, ease: 'out(3)' }));
      });
    }).observe(gal, { attributes: true, attributeFilter: ['src'] });
  });

  document.documentElement.classList.add('pw-anime-on');
})();
